











import {Component, Mixins, Prop} from 'vue-property-decorator';

import FactMixin from './FactMixin.vue';
import FactTooltip from './FactTooltip.vue';

@Component({
  name: 'FactLabel',
  components: {
    FactTooltip
  }
})
export default class FactLabel extends Mixins(FactMixin) {
}
